
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 72 12","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#151010","d":"M42 4h6v1h-6z"}}),_c('image',{attrs:{"x":"42","y":"4","width":"6","height":"1","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAABCAYAAAD9yd/wAAAAAXNSR0IArs4c6QAAABxJREFUCB1j+GyrIvprZr/Rj///1f7//y8LxewAvB8QEv/P5jwAAAAASUVORK5CYII="}}),_c('path',{attrs:{"fill":"#271311","d":"M0 0h12v12H0z"}}),_c('path',{attrs:{"fill":"#412A28","d":"M12 0h12v12H12z"}}),_c('path',{attrs:{"fill":"#363333","d":"M24 0h12v12H24z"}}),_c('path',{attrs:{"fill":"#2F2B2B","d":"M36 0h12v12H36zm12 0h12v12H48z"}}),_c('path',{attrs:{"fill":"#1B1616","d":"M60 0h12v12H60z"}})])])
          )
        }
      }
    